/** AutoMapa partner portal i18n — aligned with public AutoMapa client view preferences. */
export const AUTOMAP_PARTNER_PORTAL_I18N_MANIFEST = {
  market: { code: "CO" },
  i18n: {
    defaultLocale: "es-CO",
    supportedLocales: ["es-CO", "en-US", "ru-RU"],
    defaultCurrency: "COP",
    supportedCurrencies: ["COP", "USD", "EUR", "RUB"],
  },
};
